import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { PersonalInsurancePage } from "./pages/PersonalInsurancePage";
import { CommercialInsurancePage } from "./pages/CommercialInsurancePage";
import { IndustryPartnersPage } from "./pages/IndustryPartnersPage";
import { ContactPage } from "./pages/ContactPage";
import { ServiceRequestPage } from "./pages/ServiceRequestPage";
import { LifeInsuranceAnnuitiesPage } from "./pages/LifeInsuranceAnnuitiesPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <div className="App-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/personal-insurance" element={<PersonalInsurancePage />} />
            <Route path="/commercial-insurance" element={<CommercialInsurancePage />} />
            <Route path="/life-insurance-annuities" element={<LifeInsuranceAnnuitiesPage />} />
            <Route path="/industry-partners" element={<IndustryPartnersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/service-request" element={<ServiceRequestPage />} />
          </Routes>
        </div>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
